export enum EQueryEscalationLevel {
    First = 0,
    Second = 1,
    Third = 2,
}

export type EscalationLevelName = keyof (typeof EQueryEscalationLevel);